import React, {Fragment} from 'react'
import spinner from '../images/spinner.gif'
export const Loader = () => {
    return (
      <Fragment>
        <div className="spinner-wrapper">
          <img src={spinner} alt="spinner" />
        </div>
      </Fragment>
    );
}
